<div>
    <div class="top-section-wrapper">
        <div class="top-section">
            <div>
                <h1>brAInwatch</h1>
                <p class="sub-title">AI powered decision support tool for accute stroke diagnosis</p>
                <button color="primary" mat-raised-button routerLink="/register">Try out today</button>
            </div>
        </div>
    </div>

    <!-- First Grid -->
<div class="w3-row-padding w3-padding-64 w3-container">
    <div class="w3-content">
        <h1>Introducing our Stroke Prediction Tool: brAInwatch</h1>
        <h4 class="w3-padding-32" center>
            In times of urgency, where every second counts, meet our Mobile Stroke Unit – your reliable stroke
            companion. This smart and user-friendly app is designed to be your lifeline if you suspect a stroke. It
            seamlessly predicts stroke likelihood and promptly detects its presence, ensuring your well-being is
            safeguarded during critical moments.
        </h4>

        <div class="w3-twothird">
            <h1>1. Predicting Stroke Likelihood - Mobile Stroke Unit</h1>
            <h5 class="w3-padding-32">
                What it does:
                Our Mobile Stroke Unit is a revolutionary app designed to swiftly respond when you suspect a stroke.
                By gathering crucial medical and personal information, it predicts the likelihood of a stroke. If
                the risk is high, it initiates an immediate dispatch of a specialized medical team equipped with
                cutting-edge technology.
            </h5>
            <p class="w3-text-grey">
                Why it is important:
            </p>
            <p class="w3-text-grey">
                <b>Rapid Emergency Response</b>:In the event of a possible stroke, time becomes of the essence.
                Don't hesitate to call for an ambulance immediately if you or a loved one experiences any of the
                following symptoms: sudden numbness or weakness on one side of the face, arm, or leg, sudden
                confusion, difficulty speaking or understanding speech, sudden vision problems in one or both eyes,
                sudden difficulty walking, dizziness, loss of balance, or lack of coordination. Swift action could
                be crucial, so don't delay in seeking help by calling for an ambulance.
            </p>
            <p class="w3-text-grey">
                <b>Assessment with Comprehensive Data</b>: The app gathers vital medical and personal information,
                allowing for a holistic assessment of your stroke risk. This comprehensive approach enhances the
                accuracy of predictions and ensures tailored care.
            </p>
            <p class="w3-text-grey">
                <b>Immediate Access to Medical Experts</b> With the Mobile Stroke Unit, you are immediately
                connected to a team of stroke specialists who can make critical decisions on the spot, significantly
                improving your chances of a positive outcome.
            </p>
            <p class="w3-text-grey">
                <b>Empowering Stroke Awareness</b> Beyond emergency situations, our app raises awareness about
                stroke risk factors and the importance of early detection, fostering a proactive approach to stroke
                prevention and overall well-being.
            </p>

        </div>

        <div class="w3-third w3-center image-container" style="padding-left: 16px;">
            <img src="assets/images/mobilestroke.jpg" alt="Image description">
        </div>

        <div class="w3-third w3-center image-container">

        </div>

        <div class="w3-third w3-center image-container" style="padding-left: 16px;">
            <img src="assets/images/time.jpg" alt="Image description">
        </div>
    </div>
</div>

<!-- Second Grid -->
<div class="w3-row-padding w3-light-grey w3-padding-64 w3-container">
    <div class="w3-content">
        <div class="w3-third w3-center">
            <img src="assets/images/Screenshot 2023-07-20 112917.png" alt="Image description" width="250">
        </div>

        <div class="w3-twothird">
            <h1>2. Predicting Stroke Type and Location - CT Scan Analysis</h1>
            <h5 class="w3-padding-32">
                What it does:
                Once our Mobile Stroke Unit identifies a high likelihood of stroke, the specialized medical team on
                board conducts CT scans of your brain. Our advanced app then analyzes the results to accurately
                predict the presence, type, and location of the stroke.
            </h5>

            <p class="w3-text-grey">
                Why it is important:
            </p>
            <p class="w3-text-grey">
                <b> Advanced CT Scan Analysis</b> Through sophisticated AI algorithms, our app analyzes CT scan
                results with unmatched precision. This invaluable technology aids medical professionals in promptly
                diagnosing strokes and providing the most appropriate treatment plan.
            </p>
            <p class="w3-text-grey">
                <b> Optimized Treatment Strategies</b>: By predicting the type and location of the stroke, our app
                enables medical professionals to select the most effective treatment strategy for your specific
                condition, minimizing potential complications and maximizing recovery.
            </p>

            <p class="w3-text-grey">
                With cutting-edge CT scan analysis at your disposal, our Mobile Stroke Unit ensures that you receive
                the most precise and efficient care during critical moments. We are dedicated to safeguarding your
                well-being and delivering superior stroke management. Rest assured, we stand by your side every step
                of the way in your journey to better health.
            </p>
        </div>
    </div>
</div>

<!--Third Grid -->
<div class="w3-row-padding w3-padding-64 w3-container">
    <div class="w3-content">
        <h1><b>Introducing Our Dedicated Team</b> Bringing Innovation to Healthcare</h1>
        <h5 class="w3-padding-32" center>
            Our app was brought to life by a team of six curious and passionate students. Four of us were master's
            students at the University of Mannheim, while the other two were talented bachelor computer science
            students from Cluj. Together, we recognized the significance of timely stroke diagnosis and the
            importance of distinguishing between different types for effective treatment.
            <br>
            <br>
            Combining our coding skills with medical knowledge, we set out on a mission to develop a tool that could
            truly make a difference in the medical field. Throughout the project, we dedicated ourselves to
            extensive research, ensuring that each team member had a well-rounded understanding of the subject.
            <br>
            <br>
            Today, we are thrilled to present the result of our collaborative efforts - an innovative app with the
            potential to transform stroke diagnosis. We invite you to explore and experiment with this powerful
            tool, as we believe that together, we can positively impact the world of healthcare.
        </h5>
    </div>
</div>
</div>


